import React from 'react'
import AltHealing from '../../../../Icon/icons/AltHealing/index'
import CrystalBall from '../../../../Icon/icons/CrystalBall/index'
import EyeOfHorus from '../../../../Icon/icons/EyeOfHorus/index'
import LightHouse from '../../../../Icon/icons/LightHouse/index'
import Meditation from '../../../../Icon/icons/Meditation/index'
import Metaphysics from '../../../../Icon/icons/Metaphysics/index'
import Mind from '../../../../Icon/icons/Mind/index'
import ParanormalUnexplained from '../../../../Icon/icons/ParanormalUnexplained/index'
import SecretsCoverups from '../../../../Icon/icons/SecretsCoverups/index'
import SpiritualGrowth from '../../../../Icon/icons/SpiritualGrowth/index'
import Yoga from '../../../../Icon/icons/Yoga/index'

interface IconProps {
  size?: number
}

interface TopicIconProps {
  type: string
}

/**
 * Maps topic icon key strings (from icon-utils getTopicIcon) to
 * inline SVG Icon components. Replaces the legacy IconV2 font-based
 * icons with proper SVG components.
 */
const ICON_MAP: Record<string, React.ComponentType<IconProps>> = {
  healing: AltHealing,
  health: AltHealing,
  'yoga-2': Yoga,
  consciousness: CrystalBall,
  growth: SpiritualGrowth,
  mind: Mind,
  origins: EyeOfHorus,
  supernatural: ParanormalUnexplained,
  secrets: SecretsCoverups,
  coverups: SecretsCoverups,
  metaphysics: Metaphysics,
  'third-eye': EyeOfHorus,
  spirit: SpiritualGrowth,
  lighthouse: LightHouse,
  meditation: Meditation,
}

function TopicIcon ({ type }: TopicIconProps) {
  const IconComponent = ICON_MAP[type] || SpiritualGrowth
  return <IconComponent size={15} />
}

export default React.memo(TopicIcon)
